import React from 'react';
import { Button } from 'react-bootstrap';

const QuizQuestion = ({ prompt, options, onSelect, selectedOptionId, disabled }) => {
  return (
    <div className="quiz-question">
      <h2 className="h5 mb-4 quiz-question-prompt">{prompt}</h2>
      <div className="d-flex flex-column gap-2">
        {options.map((opt) => {
          const selected = selectedOptionId != null && opt.id === selectedOptionId;
          return (
            <Button
              key={opt.id}
              variant={selected ? 'primary' : 'outline-secondary'}
              className={`quiz-option text-center py-3 px-3 ${selected ? 'quiz-option-selected' : ''}`}
              disabled={disabled}
              onClick={() => onSelect(opt)}
              aria-pressed={selected}
            >
              {opt.text}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default QuizQuestion;
